
import { NativeStackScreenProps } from "@react-navigation/native-stack"
import { NavigatorParamList } from "~navigators"

export interface PersonalCardProps {
  userId: number
  isSendMessageButtonVisible?: boolean
}

export enum PersonalCardType {
  MOVE = "move",
  SWITCH = "switch",
  ADD = "add",
  SEND = "send",
  ACCEPT = "accept",
}

export enum PersonalItemCardType {
  SETUP = "setup",
  EVALUATE = "evaluate",
  TRANSFER = "transfer",
  REPORT = "report",
  BLACKLIST = "blacklist",
  ACCEPT = "accept",
  SEND_MSG = "sendMsg",
  ADD = "add",
  MUTE = "mute",
}


export interface PersonalCardScreenProps extends PersonalCardProps {}

export type PersonalCardScreenNavigationProps = NativeStackScreenProps<
  NavigatorParamList,
  "PersonalCard"
>
